import { render } from "./market-switcher.vue?vue&type=template&id=c755154a"
import script from "./market-switcher.vue?vue&type=script&lang=js"
export * from "./market-switcher.vue?vue&type=script&lang=js"

import "./market-switcher.vue?vue&type=style&index=0&id=c755154a&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__